import { SSRBannerManager } from '../src/SSRBannerManager.ts';

export const ssrBannerManager: SSRBannerManager = new SSRBannerManager();
